import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, X, ArrowRight } from 'lucide-react';

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 text-white overflow-hidden mt-16 md:mt-20">
      {/* Animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 animate-gradient-x opacity-75"></div>
      
      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3 gap-4">
          {/* Left side - Message */}
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="hidden sm:flex items-center justify-center w-8 h-8 bg-white/20 rounded-full flex-shrink-0 animate-pulse">
              <FileText size={16} className="text-white" />
            </div>
            <p className="text-sm sm:text-base font-medium truncate sm:whitespace-normal" data-testid="announcement-text">
              <span className="hidden sm:inline">📄 </span>
              New whitepaper: <span className="font-semibold">From Robot Data to Operational Understanding</span> — a practical data loop for deployed robot fleets.
            </p>
          </div>

          {/* Right side - CTA and Close */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            <Link
              to="/resources#whitepapers"
              data-testid="announcement-cta"
              className="inline-flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 bg-white text-purple-600 rounded-lg font-semibold text-xs sm:text-sm hover:bg-slate-100 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 whitespace-nowrap"
            >
              <span>Get the Whitepaper</span>
              <ArrowRight size={14} className="hidden sm:inline" />
            </Link>
            <button
              onClick={() => setIsVisible(false)}
              data-testid="announcement-close"
              className="p-1.5 hover:bg-white/20 rounded-lg transition-colors flex-shrink-0"
              aria-label="Close announcement"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes gradient-x {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }
        .animate-gradient-x {
          background-size: 200% 200%;
          animation: gradient-x 3s ease infinite;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBanner;
